import { useMutation } from '@tanstack/react-query'
import { useCache } from '../useCache'
import { DHL_API } from '../../api'
import { useParamsFromURL } from '../useParamsFromURL'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '../../store/useAppStore'
import { AxiosError } from 'axios'

export const useVehicleDataMutation = () => {
  const { webView: isWebView, customTab } = useParamsFromURL([
    'vehicleId',
    'webView',
    'customTab',
  ])

  const cache = useCache() as { clear: () => Promise<void> } | null
  const [t] = useTranslation()
  const setSnackbar = useAppStore((state) => state.setSnackbar)

  const {
    mutate: sendVehicleData,
    isLoading,
    isError,
  } = useMutation(
    ['sendVehicleData'],
    (body) => DHL_API.post(`api/fleet/storegear/runs`, body),
    {
      onSuccess: ({ status }) => {
        cache?.clear().then(() => {
          if (isWebView === 'true' && window.Android) {
            if (status === 200) {
              window.Android.finishVehicleDamageRegistrationApp()
            } else {
              window.Android.failVehicleDamageRegistrationApp()
            }
            customTab === 'true' && window.close()
          } else {
            window.location.reload()
          }
        })
      },
      onError: async () => {
        try {
          await cache?.clear()
          if (isWebView === 'true' && window.Android) {
            window.Android.failVehicleDamageRegistrationApp()
            customTab === 'true' && window.close()
          } else {
            window.location.reload()
          }
        } catch (error: unknown) {
          setSnackbar({
            open: true,
            message:
              (error as AxiosError)?.message ||
              t('snackbar.something_went_wrong'),
          })
        }
      },
    }
  )

  return {
    sendVehicleData,
    isLoading,
    isError,
  }
}
